/**
 * Timeline đầy đủ 8 bước của một vụ án – dùng chung cho Chi tiết vụ án (đương sự) và Chi tiết vụ án (nội bộ).
 */
import type { CaseEvent } from '../types/case'

/** Các bước tiến trình hoàn chỉnh theo quy trình tố tụng. */
export const FULL_LIFECYCLE_STAGES: { order: number; type: CaseEvent['type']; label: string; keywords: string[] }[] = [
  { order: 1, type: 'filed', label: 'Nộp đơn khởi kiện', keywords: ['nộp đơn', 'đơn đã nộp', 'tiếp nhận'] },
  { order: 2, type: 'accepted', label: 'Thụ lý vụ án', keywords: ['thụ lý', 'chấp nhận thụ lý', 'thụ lý vụ án', 'thụ lý đơn'] },
  { order: 3, type: 'assigned', label: 'Phân công Thẩm phán', keywords: ['phân công'] },
  { order: 4, type: 'session', label: 'Phiên kiểm tra chứng cứ / Chuẩn bị xét xử', keywords: ['kiểm tra chứng cứ', 'chuẩn bị', 'phiên họp'] },
  { order: 5, type: 'session', label: 'Phiên hòa giải', keywords: ['hòa giải'] },
  { order: 6, type: 'session', label: 'Phiên xét xử sơ thẩm', keywords: ['xét xử', 'phiên xét xử', 'sơ thẩm'] },
  { order: 7, type: 'decision', label: 'Tuyên án / Ban hành bản án', keywords: ['tuyên án', 'bản án', 'ban hành'] },
  { order: 8, type: 'closed', label: 'Tống đạt bản án & Kết thúc', keywords: ['tống đạt', 'gửi đương sự', 'kết thúc', 'bản án được gửi'] },
]

export type TimelineDisplayItem = CaseEvent & { isPending?: boolean }

/** Xây dựng timeline đầy đủ 8 bước: ghép sự kiện thực với placeholder "Chưa diễn ra" cho các bước chưa có. */
export function buildFullTimeline(timeline: CaseEvent[]): TimelineDisplayItem[] {
  const sorted = [...timeline].sort((a, b) => new Date(a.at).getTime() - new Date(b.at).getTime())
  const used = new Set<string>()
  const result: TimelineDisplayItem[] = []

  for (const stage of FULL_LIFECYCLE_STAGES) {
    const titleLower = (t: string) => t.toLowerCase()
    const matchesStage = (ev: CaseEvent) =>
      ev.type === stage.type && (stage.keywords.length === 0 || stage.keywords.some((kw) => titleLower(ev.title).includes(kw)))
    const found = sorted.find((ev) => !used.has(ev.id) && matchesStage(ev))
    if (found) {
      result.push({ ...found, isPending: false })
      used.add(found.id)
    } else {
      result.push({
        id: `placeholder-${stage.order}`,
        type: stage.type,
        title: stage.label,
        description: 'Chưa diễn ra',
        at: '',
        isPending: true,
      })
    }
  }
  return result
}
